import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  microcopy?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'gold';
  tone?: 'light' | 'dark';
};
export function CtaButton({
  children,
  href = '#offer',
  microcopy,
  fullWidth = true,
  variant = 'primary',
  tone = 'light'
}: CtaButtonProps) {
  const palette = variant === 'gold' ? 'bg-gold text-ivory-light hover:bg-[#7C5F22] focus-visible:outline-gold' : 'bg-teal text-ivory-light hover:bg-teal-dark focus-visible:outline-teal';
  return <div className={fullWidth ? 'w-full' : 'inline-block'} data-id="element-41" data-mp="109ljmaropc9c">
      <a href={href} onClick={() => {
      if (href.startsWith('http')) {
        trackInitiateCheckout();
      }
    }} className={`group inline-flex ${fullWidth ? 'w-full' : ''} items-center justify-center gap-2 rounded-full px-6 py-4 text-[13px] font-semibold uppercase tracking-[0.12em] shadow-card transition-[transform,background-color] duration-150 ease-out will-change-transform hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:text-sm ${palette}`} data-id="element-42" data-mp="vb0nonjgteqp">
        {children}
        <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-43" data-mp="3jyibto2zinnb" />
      </a>
      {microcopy ? <p className={`mt-3 text-center text-[11px] font-medium uppercase tracking-[0.1em] sm:text-xs ${tone === 'dark' ? 'text-ivory/55' : 'text-navy-soft'}`} data-id="element-44" data-mp="3sw2ff3obkw13">
          {microcopy}
        </p> : null}
    </div>;
}